// Maps internal expoAccountName (stored in publication docs) to the account
// slug used in Expo dashboard URLs (expo.dev/accounts/<slug>/...).
// Add a new entry whenever a new Expo account is onboarded.
const EXPO_ACCOUNT_URL_SLUGS = {
    'nuvemshop1': 'nuvemshop1mobilizei',
    'nuvemshop2': 'nuvemshop2mobilizei',
    'nuvemshop3': 'nuvemshop3mobilizei',
    'nuvemshop4': 'nuvemshop4mobilizei',
    'tray1': 'tray1mobilizei',
    'tray2': 'tray2mobilizei',
    'tray3': 'tray3mobilizei',
    'tray4': 'tray4mobilizei',
    'tray5': 'tray5mobilizei',
    'tray6': 'tray6mobilizei',
    'tray7': 'tray7mobilizei',
    'webview1': 'webview1mobilizei',
    'webview2': 'webview2mobilizei',
    'webview3': 'webview3mobilizei',
    'wix1': 'wix1mobilizei',
    'convertr1': 'convertr1',
    'convertr2': 'convertr2',
    'lojaintegrada1': 'lojaintegrada1mobilizei',
    'lojaintegrada2': 'lojaintegrada2mobilizei',
    'irroba1': 'irroba1mobilizei',
};

export function mapExpoAccountNameToUrlSlug(expoAccountName) {
    return EXPO_ACCOUNT_URL_SLUGS[expoAccountName] || expoAccountName;
}
